import { render, staticRenderFns } from "./OPCParam.vue?vue&type=template&id=470503bd"
import script from "./OPCParam.vue?vue&type=script&lang=js"
export * from "./OPCParam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports